/** @jsx jsx */

import React, {
  Fragment as _,
  createContext,
  useContext,
  useState,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import { State } from 'store/store';
import setBlockProps from 'services/apiHelpers/setBlockProps';

export const MediaContext = createContext(null) as any;

interface IMediaProps {
  id: string;
  onMediaChange?: (child: number) => void;
  children: any;
}
const Media = (props: IMediaProps) => {
  const { onMediaChange, children } = props;

  const { parent, child } = useSelector((state: State) => {
    const parent = state.blocks[props.id];
    return {
      parent,
      child: parent?.props?.child,
    };
  });

  useEffect(() => {
    if (!children[child]) {
      console.log(
        `children[( index = ) ${child}] does not exist on legacy block. resetting media component to image`
      );
      setBlockProps(parent, { child: 1 });
    }
  }, [child]);

  useEffect(() => {
    if (!onMediaChange || typeof onMediaChange !== 'function') {
      return;
    }

    onMediaChange(child);

    return () => {
      //
    };
  }, [child]);

  if (!children[child]) {
    // return null if child doesn't exist. reset in effect
    return null;
  }

  return children[child];
};

export default Media;
